enum ActionTypes {
  LAYOUT_HIDE_INACTIVE_SAMPLE_POINT_ERROR_MODAL = 'LAYOUT_HIDE_INACTIVE_SAMPLE_POINT_ERROR_MODAL',
  LAYOUT_HIDE_NAVIGATION = 'LAYOUT_HIDE_NAVIGATION',
  LAYOUT_SHOW_INACTIVE_SAMPLE_POINT_ERROR_MODAL = 'LAYOUT_SHOW_INACTIVE_SAMPLE_POINT_ERROR_MODAL',
  LAYOUT_SHOW_NAVIGATION = 'LAYOUT_SHOW_NAVIGATION'
}

export default ActionTypes;
